import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_4: FaireProductEntity = {
  token: "atc_baggu_4",
  type: "product",
  name: "3D Orange Charm",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a19b69b2aa52bfd6c57ce887cc17ec44105fa453f8539f50eeecbb56bbfe9086.jpeg",
  priceDollars: 12,
  msrpDollars: 24,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
